<template>
  <qx-card title="列表">
    <OpenBillDialog ref="openBillDialog" @sub="getData" />
    <RateDialog ref="rateDialog" />
    <span slot="titleLeft">
      【不可开票：
      <span class="primary">{{
        tableData.originData.withdrawAmountNot || 0
      }}</span
      >】 【可开票：
      <span class="primary">{{
        tableData.originData.withdrawAmountCan || 0
      }}</span
      >】 【服务费：
      <span class="primary">{{
        tableData.originData.billServiceAmountTitie || 0
      }}</span
      >】
    </span>
    <LogRightDialog ref="logRightDialog" busiCode="22000027" />
    <section slot="titleRight">
      <qx-permpisions permpisions="2000922">
        <el-button type="primary" plain @click="() => quickOpenBill()"
          >快速打包申请</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions="2000903">
        <el-button type="primary" plain @click="openBill"
          >打包申请开票</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions="2000917">
        <ImportBtn
          title="批量打包申请"
          btnName="批量打包申请"
          :isDownloadLocalTemplate="true"
          fileUrl="/file/批量打包申请模板.xlsx"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="2000902">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="billManageBO.ajax?cmd=doQueryApplicationRecord"
          :params="fullSearchData"
          bizName="开票申请信息导出"
          bizCode="exp20000"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'orderId'"
                  @click="toOrderDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="120"
          >
            <template slot-scope="scope">
              <section>
                <qx-permpisions permpisions="2000918">
                  <span
                    class="primary cur"
                    @click="showRate(scope.row.tenantId)"
                    >查看费率</span
                  >
                </qx-permpisions>
                <qx-permpisions permpisions>
                  <span class="primary cur" @click="showLog(scope.row.flowId)"
                    >日志</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import RateDialog from './rateDialog';
import ImportBtn from 'components/importBtn';
import OpenBillDialog from './openBillDialog';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  invoiceApplyList,
  invoiceQueryOpenBillDay,
  invoiceFastOpenBillFlowId,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ImportBtn,
    RateDialog,
    LogRightDialog,
    ExportBtn,
    OpenBillDialog,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        originData: {},
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'flowId',
        title: [ // 表头
          { prop: 'orderId', label: '订单号码', fixed: true },
          { prop: 'dependTime', label: '发车时间' },
          { prop: 'plateNumber', label: '车牌号码' },
          { prop: 'vehicleClassName', label: '车辆种类' },
          { prop: 'cashDouble', label: '现金' },
          { prop: 'oilDouble', label: '油费' },
          { prop: 'etcDouble', label: 'ETC' },
          { prop: 'incomeDouble', label: '抵扣金额' },
          { prop: 'withdrawAmountDouble', label: '提现金额' },
          { prop: 'noWithdrawAmountDouble', label: '未提现金额' },
          { prop: 'payAcctName', label: '付款账户名' },
          { prop: 'receiveAcctName', label: '收款账户名' },
          { prop: 'openBillUser', label: '开票方' },
          { prop: 'billServiceAmountDouble', label: '票据服务费' },
          { prop: 'billStateName', label: '状态' },
          { prop: 'applyNum', label: '申请号码' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: invoiceApplyList,
    async checkOpenBillDay (success) { // 验证当前日期是否在可开票日期范围内
      const res = await invoiceQueryOpenBillDay();
      if (!res.failed) {
        if (res.openBillDate) {
          const day = res.openBillDate.split('-');
          const today = new Date().getDate();
          if (today < day[0] || today > day[1]) {
            this.$message.error('本月申请开票时间已结束，请在下一个开票周期再支付。');
          } else {
            success && success();
          }
        }
      }
    },
    quickOpenBill (searchBoxData) { // 快速打包申请
      this.checkOpenBillDay(async () => {
        if (searchBoxData && !searchBoxData.receiveAcctName) {
          this.$message.warning('请输入收款账户名');
        } else if (searchBoxData && !searchBoxData.payAcctName) {
          this.$message.warning('请输入付款账户名');
        } else if (searchBoxData && searchBoxData.billState !== '2') {
          this.$message.warning('状态请选择‘可申请开票’');
        } else if (searchBoxData) {
          const res = await invoiceFastOpenBillFlowId(searchBoxData);
          this.$refs.openBillDialog.show(res.items.map((flowId) => ({
            flowId,
          })));
        } else {
          this.$emit('query', 'quickOpenBill');
        }
      });
    },
    openBill () { // 打包申请开票
      if (this.tableData.selectResult.length === 0) {
        this.$message.warning('请先选择操作对象');
        return;
      }
      const payAcctName = []; // 付款账户名
      const receiveAcctName = []; // 收款账户名
      const openBillUser = []; // 开票方
      for (let i = 0; i < this.tableData.selectResult.length; i++) {
        if (this.tableData.selectResult[i].billState !== 2) {
          this.$message.warning(`订单号[${this.tableData.selectResult[i].orderId}]状态不是可申请开票，不允许打包开票。`);
          return;
        }
        payAcctName.push(this.tableData.selectResult[i].payAcctName);
        receiveAcctName.push(this.tableData.selectResult[i].receiveAcctName);
        openBillUser.push(this.tableData.selectResult[i].openBillUser);
      }
      for (let i = 0; i < payAcctName.length; i++) {
        if (i !== 0 && payAcctName[i] !== payAcctName[i - 1]) {
          this.$message.warning(`付款账户名[${payAcctName[i]}]与前面的付款账户名不相同，不允许打包开票。`);
          return;
        }
      }
      for (let i = 0; i < receiveAcctName.length; i++) {
        if (i !== 0 && receiveAcctName[i] !== receiveAcctName[i - 1]) {
          this.$message.warning(`收款账户名[${receiveAcctName[i]}]与前面的收款账户名不相同，不允许打包开票。`);
          return;
        }
      }
      for (let i = 0; i < openBillUser.length; i++) {
        if (i !== 0 && openBillUser[i] !== openBillUser[i - 1]) {
          this.$message.warning(`开票方[${openBillUser[i]}]与前面的开票方不相同，不允许打包开票。`);
          return;
        }
      }
      this.checkOpenBillDay(() => {
        this.$refs.openBillDialog.show(this.tableData.selectResult);
      });
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    showRate (id) {
      this.$refs.rateDialog.show(id);
    },
    toOrderDetail (item) {
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
